module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "aria-labelledby": "headerpt01t01",
      "epub:type": "part",
      "id": "pt01t",
      "role": "doc-part"
    }
  }, [_c('header', {
    attrs: {
      "id": "headerpt01t01"
    }
  }, [_c('h1', {
    staticClass: "ct"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "8",
      "epub:type": "pagebreak",
      "id": "p8",
      "role": "doc-pagebreak"
    }
  }), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "9",
      "epub:type": "pagebreak",
      "id": "p9",
      "role": "doc-pagebreak"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chikuklick0007#toc"
    }
  }, [_vm._v("Why Fascism?")])])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p9"
    }
  }), _vm._v("Part 1 surveys fascism during a period that ended in the aftermath of World War Two, a war in which Italy, Germany, and Japan had existentially threatened the United States. During this period of some forty years, fascists had a checkered and complex history. After Mussolini took over Italy during the 1920s, the United States initially honored his regime, and its success caused American intellectuals to look back differently at their own politics of the first decade of the twentieth century. By the late 1930s, however, fascists had become indistinct villains—the noun might apply to anyone but did so with increasing negativity. Then, when the United States entered World War Two, the term was affixed to certain kinds of politicians on the right—it received a more or less secure locus. For some fifteen years, from the early 1930s to the late 1940s, fascism was a way of categorizing at the forefront of collective American brooding, and after that era it remained the word of choice when a certain kind of condemnation was required."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chikuklick0027#en2",
      "id": "en2r",
      "role": "doc-noteref"
    }
  }, [_vm._v("1")])]), _vm._v(" Why is it fascism—and not one of the many other items of vilification that came to the lips of Americans during the late 1930s and early 1940s—that has survived for a century?")]), _vm._v(" "), _c('p', [_vm._v("Mussolini constructed fascism. While Adolf Hitler did not dispute fascism as an approach to understanding his rule in Germany, he did little to exploit it, and the Germans never sought the phraseology. Even scholars know the adherents of National Socialism in Germany as the Nazis. The Germans of the Nationalsozialistische Deutsche Arbeiterpartei (NSDAP)—the National Socialist German Workers Party—never employed Nazi, for it was an idiom of reproach. It originated as a colloquial affront for a clumsy peasant. Then, following "), _c('i', [_vm._v("Sozi")]), _vm._v(" to pillory German socialists during the 1920s, "), _c('i', [_vm._v("Nazi")]), _vm._v("—playing on "), _c('span', {
    staticClass: "bi"
  }, [_vm._v("Na")]), _vm._v("tionalso"), _c('span', {
    staticClass: "bi"
  }, [_vm._v("zi")]), _vm._v("alistische—mocked that party’s members as repugnant rednecks. Exiles from Germany used the demeaning name after Hitler took over, "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "10",
      "epub:type": "pagebreak",
      "id": "p10",
      "role": "doc-pagebreak"
    }
  }), _vm._v("and then it spread in anti-German lands as the repellent characterization for his government.")]), _vm._v(" "), _c('p', [_vm._v("Contemporary academics render German documents that mention “the NSDAP” as “Nazi” in English. This is extraordinarily prejudicial. We may liken it to a scholar translating “the United States” in official government texts as “AmeriKa” (with a "), _c('i', [_vm._v("K")]), _vm._v("), and about as neutral. So why not latch on to Nazi, at one time as negative as fascist and more conspicuously German, as the pejorative of choice? Or Hitlerism?")]), _vm._v(" "), _c('p', [_vm._v("During the World War Two period, US policy specialists linked German and Italian ideology to the Japanese. But in Japan itself, the controlling military never had a Western-style name connected to fascism. Tojoism, after Hideki Tojo, the most prominent Japanese leader, never caught on as execration. For Americans, these Asian views were “Japanese fascism.”")]), _vm._v(" "), _c('p', [_vm._v("One regime nominated itself as fascism: Italy."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chikuklick0027#en3",
      "id": "en3r",
      "role": "doc-noteref"
    }
  }, [_vm._v("2")])]), _vm._v(" Part of the reason for the later omnipresence of fascism may simply be that the Italians had the name first. For a few years after Hitler rose to command, he was subordinate to Mussolini, and fascism signified the sort of polity that the National Socialists secondarily exemplified. We had a fascist genus and two species in Hitler and Mussolini—and later Japan. Yet these details, I believe, hardly explain why fascism was victorious, especially since, by the mid-1930s, bystanders had often spoofed the Italians as doltish and bungling and not people who incarnated wickedness.")]), _vm._v(" "), _c('p', [_vm._v("There is no good answer to the question, Why fascism? Nor is it at all clear what fascist had conveyed by the late 1930s. Neither Italians nor Japanese primarily came to mind. Speakers of political English, moreover, did not always think that the non-Italian “Caucasians” or “Nordics” referred to were German. Even when words like Nazi or Hitlerite were deployed as a kind of substitute for fascist, they, too, ceased to have an essential connection to Germany. These peculiarities frame the discussion in "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chikuklick0009#pt01"
    }
  }, [_vm._v("part 1")]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dde453f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-kuklick-0010.vue
// module id = 81
// module chunks = 0